import { SearchCombobox } from "@/components/ui/search-combobox";
import { searchLocations } from "@/lib/snipeit/locations";
import type { SnipeItLocation } from "@/lib/snipeit/types";

interface LocationPickerProps {
  sourceLocation: SnipeItLocation;
  targetInput: string;
  onTargetInputChange: (value: string) => void;
  onTargetSelect: (loc: SnipeItLocation) => void;
}

export function LocationPicker({
  sourceLocation,
  targetInput,
  onTargetInputChange,
  onTargetSelect,
}: LocationPickerProps) {
  return (
    <div className="flex flex-col items-stretch gap-3 md:flex-row md:items-end md:gap-4">
      <div className="flex-1 space-y-1">
        <label className="text-muted-foreground text-xs font-medium">Aktueller Standort</label>
        <div className="border-border bg-muted/50 text-foreground rounded-md border px-3 py-2 text-sm">
          {sourceLocation.name}
        </div>
      </div>
      <div className="text-muted-foreground hidden items-center pb-2 text-lg md:flex">→</div>
      <div className="flex-1 space-y-1">
        <label className="text-muted-foreground text-xs font-medium">Ziel-Standort</label>
        <SearchCombobox
          placeholder="Standort suchen…"
          queryKey="target-location"
          searchFn={(query) =>
            searchLocations(query).then((results) =>
              results
                .filter((loc) => loc.id !== sourceLocation.id)
                .map((loc) => ({ id: loc.id, label: loc.name, data: loc })),
            )
          }
          value={targetInput}
          onInputChange={onTargetInputChange}
          onSelect={(result) => onTargetSelect(result.data as SnipeItLocation)}
        />
      </div>
    </div>
  );
}
